define('lib/util/zip',['jquery', 'cookies', './tda.config'], function ($, cookies, tdaConfig) {

  var __zipRegex = /^\d{5}(-\d{4})?$/;

  return {
    // taken from zipTools
    isZipFormatValid: function (testZip) {
      return __zipRegex.test(testZip);
    },

    // returns default zip code for current TDA (configured via TDA_config DCR)
    getDefault: function () {
      return tdaConfig.tda.default_zip;
    },

    getCookied: function () {
      return cookies.getItem('zip'); // whats the diff with zip and zipCode cookie?
    },

    // returns the cookied zip if available, else returns default
    // Replaces SU.getZip()
    getCookiedDefaultFallback: function () {
      var cookied = this.getCookied();
      if (this.isZipFormatValid(cookied)) {
        return cookied;
      }
      return this.getDefault();
    }
  };
});

